import React from "react";
import { FormLabel as FormLabel$1 } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useClasses = makeStyles()((theme) => ({
  formLabelCaption: {
    textTransform: "uppercase",
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight,
    letterSpacing: 1,
    fontWeight: 500,
    padding: theme.spacing(0.5, 0)
  },
  formLabelDefault: {
    color: theme.custom.palette.content.headingText,
    padding: theme.spacing(1, 0)
  }
}));
function FormLabel({ label, labelVariant }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(
    FormLabel$1,
    {
      focused: false,
      className: cx({
        [classes.formLabelCaption]: labelVariant === "caption",
        [classes.formLabelDefault]: labelVariant === "default"
      })
    },
    /* @__PURE__ */ React.createElement(LocalizedText, { label })
  );
}
export {
  FormLabel
};
//# sourceMappingURL=FormLabel.js.map
